/* eslint-disable func-names */
import { mensagemCampoObrigatorio } from '@core/util/mensagemUtil';
import configuracaoBanco from 'app/utils/configuracaoBanco';
import moment from 'moment';
import * as Yup from 'yup';

const dataMenorQueAtual = (data) => {
  if (!data || !data.date) {
    return true;
  }

  const amanha = moment().add(1, 'day');

  return amanha.isAfter(data);
};

export const dataEncerramentoMenorQueDataSaldo = (dataEncerramento, dataSaldo) => {
  if (dataEncerramento && dataSaldo) {
    return dataEncerramento.isSameOrAfter(dataSaldo);
  }

  return true;
};

function testAgencia(value = '', bancoCodigo) {
  if (!value) return true;

  if (configuracaoBanco.get(bancoCodigo)?.agencia) {
    return value.length <= configuracaoBanco.get(bancoCodigo)?.agencia;
  }
  return true;
}

const testConta = (value, digitos, bancoCodigo) => {
  if (!value) return true;

  if (configuracaoBanco.get(bancoCodigo)?.conta) {
    return value.length <= configuracaoBanco.get(bancoCodigo)?.conta;
  }

  return true;
};

export const useContaBancariaValidation = () =>
  Yup.object().shape({
    descricao: Yup.string()
      .nullable()
      .required(mensagemCampoObrigatorio('a descrição'))
      .max(30, 'A descrição não pode ultrapassar 30 caracteres')
      .min(3, 'É necessário informar pelo menos 3 caracteres no campo'),
    contaBancaria: Yup.object().shape({
      tipoConta: Yup.string().required('É necessário informar um tipo'),
      bancoId: Yup.string()
        .nullable()
        .required(mensagemCampoObrigatorio('o banco')),
      agencia: Yup.string()
        .max(10, 'não pode ultrapassar 10 dígitos')
        .test('agenciaBanco', 'Não pode ultrapassar 4 dígitos', function(value) {
          return testAgencia(value, this.parent.bancoCodigo);
        })
        .required(mensagemCampoObrigatorio('a agência')),
      agenciaDigito: Yup.string().nullable(),
      numeroConta: Yup.string()
        .required(mensagemCampoObrigatorio('a conta'))
        .max(10, 'não pode ultrapassar 10 dígitos')
        .test('conta8', 'Não pode ultrapassar 7 dígitos', function(value) {
          return testConta(value, 7, this.parent.bancoCodigo);
        })
        .test('conta8', 'Não pode ultrapassar 8 dígitos', function(value) {
          return testConta(value, 8, this.parent.bancoCodigo);
        }),
      contaDigito: Yup.string().required(mensagemCampoObrigatorio('o dígito')),
      saldoInicial: Yup.string().required(mensagemCampoObrigatorio('o saldo inicial')),
      dataSaldo: Yup.object()
        .nullable()
        .test('ltDataAtual', 'A data do saldo não pode ser maior que a data atual', dataMenorQueAtual)
        .required(mensagemCampoObrigatorio('a data do saldo')),
      principal: Yup.bool().required(),
      dataEncerramento: Yup.object()
        .nullable()
        .test('encerrar', mensagemCampoObrigatorio('a data de encerramento'), function(dataEncerramento) {
          return !this.parent.encerrarConta || !!dataEncerramento;
        })
        .test('ltDataAtual', 'A data do encerramento não pode ser maior que a data atual', dataMenorQueAtual)
        .test(
          'dataEncerramentoMaiorQueDataSaldo',
          'A data de encerramento deve ser igual ou maior que a data do saldo inicial',
          function(dataEncerramento) {
            return dataEncerramentoMenorQueDataSaldo(dataEncerramento, this.parent.dataSaldo);
          }
        ),
    }),
  });
